import React from "react";
import Slider from "react-slick";
import { FaHeadset, FaStar, FaSyncAlt, FaTruck } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      icon: <FaSyncAlt size={32} />,
      title: "14-Day Returns",
      description: "Risk-free shopping with easy returns.",
    },
    {
      id: 2,
      icon: <FaTruck size={32} />,
      title: "Free Shipping",
      description: "No extra costs, just the price you see.",
    },
    {
      id: 3,
      icon: <FaHeadset size={32} />,
      title: "24/7 Support",
      description: "24/7 support, always here just for you.",
    },
    {
      id: 4,
      icon: <FaStar size={32} />,
      title: "Member Discounts",
      description: "Special prices for our loyal customers.",
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,       
    autoplaySpeed: 3000,  
  };

  return (
     <div className="bg-white">
      <div className="d-md-none">
        <Slider {...sliderSettings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="text-center p-3">
              <div className="icon-box d-flex flex-column align-items-center">
                <div className="mb-2 text-dark">{testimonial.icon}</div>
                <h5 className="mb-1 small fw-semibold">{testimonial.title}</h5>
                <p className="text-muted small ">{testimonial.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="d-none d-md-block">
      <div className="container" style={{ maxWidth: "1300px" }}>
        <div className="row justify-content-center">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="col-md-3 text-center mb-4">
              <div className="icon-box d-flex flex-column align-items-center">
                <div className="mb-2 text-dark">{testimonial.icon}</div>
                <h5 className="mb-1">{testimonial.title}</h5>
                <p className="fw-8">{testimonial.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default Testimonials;
